import React, { Component } from "react"
import { Toggle } from "material-ui"
import { IResourcePlannerScheduleFilter, IJobDocument } from "../../../models"
import strings from "../../../localization/strings"
import AccountPositionChips from "../../position/accont_position_chip/AccountPositionChips"
import MultiClientChips from "../../clients/choose_client/MultiClientChips"
import JobsChip from "../../job/JobsChip"
import * as api from "../../../api"
import AccountStore from "../../../stores/AccountStore"

interface IProps {
    editFilterTemplate: IResourcePlannerScheduleFilter
}
interface IState {
    filterData: IResourcePlannerScheduleFilter
    selectedJobs: IJobDocument[]
}

export default class AddResourcePlannerScheduleFilterTemplateDialogContainer extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            filterData: props.editFilterTemplate ?
                props.editFilterTemplate :
                {
                    Id: "",
                    Name: "",
                    HideCoreStaff: false,
                    HideFloatStaff: false,
                    HidePerDiemStaff: false,
                    HideAgencyStaff: false,
                    ViewOnlyProductiveShifts: false,
                    ViewUnscheduledStaff: false,
                    ViewOnlyFilledShifts: false,
                    ViewOnlyUnfilledShifts: false,
                    BasePositionIds: [],
                    ClientIds: [],
                    JobIds: []
                } as IResourcePlannerScheduleFilter,
            selectedJobs: []
        }
    }

    componentDidMount() {
        this.state.filterData && this.state.filterData.JobIds && this.state.filterData.JobIds.length > 0 &&
            api.getJobsByIds(this.state.filterData.JobIds).then(res =>
                this.setState({ selectedJobs: res.data })
            )
    }

    render() {
        const { filterData } = this.state
        return (
            <div>
                <div style={{ marginTop: 25 }}>
                    <div style={{ display: "flex", marginBottom: 5 }}>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-Hide-Core-Staff`}
                                label={strings.Hide_Core_Staff}
                                onToggle={(e, value) => this.setState({ filterData: { ...filterData, HideCoreStaff: value } })}
                                toggled={filterData.HideCoreStaff}
                                style={{ width: 250 }}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-Hide-Float-Staff`}
                                label={strings.Hide_Float_Staff}
                                onToggle={(e, value) => this.setState({ filterData: { ...filterData, HideFloatStaff: value } })}
                                toggled={filterData.HideFloatStaff}
                                style={{ width: 250 }}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", marginBottom: 5 }}>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-Hide-Per-Diem-Staff`}
                                label={strings.Hide_Per_Diem_Staff}
                                onToggle={(e, value) => this.setState({ filterData: { ...filterData, HidePerDiemStaff: value } })}
                                toggled={filterData.HidePerDiemStaff}
                                style={{ width: 250 }}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Toggle
                                data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-Hide-Agency-Staff`}
                                label={strings.Hide_Agency_Staff}
                                onToggle={(e, value) => this.setState({ filterData: { ...filterData, HideAgencyStaff: value } })}
                                toggled={filterData.HideAgencyStaff}
                                style={{ width: 250 }}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: 25 }}>
                    <div style={{ flex: 1 }}>
                        <Toggle
                            data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-View-Only-Productive-Shifts`}
                            label={strings.View_Only_Productive_Shifts}
                            onToggle={(e, value) => this.setState({ filterData: { ...filterData, ViewOnlyProductiveShifts: value } })}
                            toggled={filterData.ViewOnlyProductiveShifts}
                            style={{ width: 250 }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <Toggle
                            data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-View-Unscheduled-Staff`}
                            label={strings.View_Unscheduled_Staff}
                            onToggle={(e, value) => this.setState({ filterData: { ...filterData, ViewUnscheduledStaff: value } })}
                            toggled={filterData.ViewUnscheduledStaff}
                            style={{ width: 250 }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: 25 }}>
                    <div style={{ flex: 1 }}>
                        <Toggle
                            data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-View-Only-Filled-Shifts`}
                            label={strings.View_Only_Filled_Shifts}
                            onToggle={(e, value) => this.setState({ filterData: { ...filterData, ViewOnlyFilledShifts: value, ViewOnlyUnfilledShifts: value ? false : filterData.ViewOnlyUnfilledShifts } })}
                            toggled={filterData.ViewOnlyFilledShifts}
                            style={{ width: 250 }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <Toggle
                            data-intercom-target={`Add-Resource-Planner-Schedule-Filter-Template-Dialog-Toggle-View-Only-Unfilled-Shifts`}
                            label={strings.View_Only_Unfilled_Shifts}
                            onToggle={(e, value) => this.setState({ filterData: { ...filterData, ViewOnlyUnfilledShifts: value, ViewOnlyFilledShifts: value ? false : filterData.ViewOnlyFilledShifts } })}
                            toggled={filterData.ViewOnlyUnfilledShifts}
                            style={{ width: 250 }}
                        />
                    </div>
                </div>
                <div style={{ marginTop: 30 }}>
                    <AccountPositionChips
                        readonly={false}
                        error={null}
                        label={strings.Filter_by_Selected_Positions}
                        selectedPositionIds={filterData.BasePositionIds || []}
                        handleChange={positions => this.setState({ filterData: { ...filterData, BasePositionIds: positions.map(i => i.BasePositionId) } })}
                    />
                </div>
                {AccountStore.getClientsEnabled() &&
                    <div style={{ marginTop: 30 }}>
                        <MultiClientChips
                            readonly={false}
                            error={null}
                            label={strings.Filter_by_Selected_Clients}
                            selectedClientIds={filterData.ClientIds || []}
                            handleChange={clients => this.setState({ filterData: { ...filterData, ClientIds: clients.map(i => i.Id) } })}
                        />
                    </div>
                }
                {AccountStore.getJobsEnabled() &&
                    <div style={{ marginTop: 30 }}>
                        <JobsChip
                            multiSelectable
                            error={null}
                            label={strings.Filter_by_Selected_Jobs}
                            labelStyle={{ fontSize: 16 }}
                            selectedJobs={this.state.selectedJobs}
                            handleSave={selectedJobs => this.setState({
                                selectedJobs,
                                filterData: { ...filterData, JobIds: selectedJobs.map(i => i.Id) }
                            })}
                        />
                    </div>
                }
            </div>
        )
    }
}
